import { FolderView } from '../api/opoint.schemas.ts'
import { FolderType } from '../constants/folders'

export const getUserOwnedProfileFolders = (folders: FolderView[], userId: number) =>
  folders.filter(
    (folder) => folder.type === FolderType.PROFILES && folder.traits === 0 && userId === folder.owner.id_user,
  )
